import { motion } from "framer-motion";

import Button from './Button';

const NewEcosystem = () => {

    const animation = (delay, xStart, xEnd, yStart, yEnd) => {
        const result = {
            initial: { opacity: 0, x: xStart, y: yStart },
            whileInView: { opacity: 1, x: xEnd, y: yEnd },
            viewport: { once: true },
            transition: {
                ease: "easeInOut",
                duration: 0.6,
                delay: delay,
            }
        }
        return result;
    }

    return (
        <>


            <div className='px-[5%]  mt-[250px] mb-[250px]'>
                <div className='flex flex-col items-center justify-center'>
                    <motion.div {...animation(0.4, 0, 0, -50, 0)} className='text-8xl xl:text-6xl uppercase font-bold mb-10 text-center bg-gradient-to-r from-green-300 to-green-500 text-transparent bg-clip-text'>Pioneering a New Era <br /> on Abstract</motion.div>
                    <motion.div {...animation(0.4, 0, 0, 50, 0)} className='desc text-center text-2xl w-1/2'>MondrianSwap is the first of its kind on the Abstract blockchain, designed to harness volatility-driven arbitrage like never before. No other ecosystem has unlocked this value potential—until now.</motion.div>
                    <motion.div {...animation(0.6, 0, 0, 50, 0)} className='mt-10'>
                        <a href="https://modrianswap.gitbook.io/modrianswap" target="_blank" rel="noopener noreferrer">
                            <Button text={'READ DOCS'} outline={true} />
                        </a>
                    </motion.div>
                </div>
            </div>
        </>
    );
};
export default NewEcosystem;
